import {CONTRACTOR_QUALIFICATIONS_REQUEST, CONTRACTOR_QUALIFICATIONS_SUCCESS, CONTRACTOR_QUALIFICATIONS_FAILURE} from '../actions';
import {STORE_CONTRACTOR_QUALIFICATION_REQUEST, STORE_CONTRACTOR_QUALIFICATION_SUCCESS, STORE_CONTRACTOR_QUALIFICATION_FAILURE} from '../actions';
import {UPDATE_CONTRACTOR_QUALIFICATION_REQUEST, UPDATE_CONTRACTOR_QUALIFICATION_SUCCESS, UPDATE_CONTRACTOR_QUALIFICATION_FAILURE} from '../actions';
import {
    QUALIFICATION_DOCUMENT_UPLOAD_REQUEST,
    QUALIFICATION_DOCUMENT_UPLOAD_SUCCESS,
    QUALIFICATION_DOCUMENT_UPLOAD_FAILURE,
    QUALIFICATION_DOCUMENT_DELETE_REQUEST,
    QUALIFICATION_DOCUMENT_DELETE_SUCCESS,
    QUALIFICATION_DOCUMENT_DELETE_FAILURE
} from '../actions';
import qualificationReducer from './contractor-qualification';

export const CONTRACTOR_QUALIFICATIONS_INITIAL_STATE = {
    isFetching: false,
    data: [],
    error: null
};

const updateQualification = (state, action) => {
    let {data} = state;
    const {id} = action;
    const insurance = data.find(b => b.id === id);
    data.splice(data.indexOf(insurance), 1);
    const reduced = qualificationReducer(insurance, action);
    data = [...state.data, reduced];

    return {...state, data};
};

const qualificationsReducers = {
    [CONTRACTOR_QUALIFICATIONS_REQUEST]: (state) => {
        return {...state, isFetching: true, error: null};
    },
    [CONTRACTOR_QUALIFICATIONS_SUCCESS]: (state, {res}) => {
        return {...state, ...res, isFetching: false, error: null};
    },
    [CONTRACTOR_QUALIFICATIONS_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error};
    },
    [STORE_CONTRACTOR_QUALIFICATION_REQUEST]: (state, action) => {
        const insurance = qualificationReducer(undefined, action);
        const data = [...state.data.filter(b => !b.draft), insurance];

        return {...state, data};
    },
    [STORE_CONTRACTOR_QUALIFICATION_SUCCESS]: (state, action) => {
        let {data} = state;
        const insurance = data.find(b => b.draft);
        data.splice(data.indexOf(insurance), 1);
        const reduced = qualificationReducer(insurance, action);
        data = [...data, reduced];

        return {...state, data};
    },
    [STORE_CONTRACTOR_QUALIFICATION_FAILURE]: (state, action) => {
        let {data} = state;
        const insurance = data.find(b => b.draft);
        data.splice(data.indexOf(insurance), 1);
        const reduced = qualificationReducer(insurance, action);
        data = [...state.data, reduced];

        return {...state, data};
    },
    [UPDATE_CONTRACTOR_QUALIFICATION_REQUEST]: updateQualification,
    [UPDATE_CONTRACTOR_QUALIFICATION_SUCCESS]: updateQualification,
    [UPDATE_CONTRACTOR_QUALIFICATION_FAILURE]: updateQualification,
    [QUALIFICATION_DOCUMENT_UPLOAD_REQUEST]: updateQualification,
    [QUALIFICATION_DOCUMENT_UPLOAD_SUCCESS]: updateQualification,
    [QUALIFICATION_DOCUMENT_UPLOAD_FAILURE]: updateQualification,
    [QUALIFICATION_DOCUMENT_DELETE_REQUEST]: updateQualification,
    [QUALIFICATION_DOCUMENT_DELETE_SUCCESS]: updateQualification,
    [QUALIFICATION_DOCUMENT_DELETE_FAILURE]: updateQualification
};

export default function qualifications(state = CONTRACTOR_QUALIFICATIONS_INITIAL_STATE, action) {
    let reducer = qualificationsReducers[action.type] || (state => state);
    return reducer(state, action);
}


// WEBPACK FOOTER //
// ./resources/assets/js/reducers/contractor-qualifications.js